import React from "react";
import Card from "../Card";
import CardData from "../CardData";
import { ShouldRender } from "../../../shared/basic/ShouldRender";
import { Spin } from "antd";

interface IRegisterSection {
  loading: boolean;
  registration: number;
}

const RegisterSection: React.FC<IRegisterSection> = ({
  loading,
  registration,
}) => {
  const cardDate = {
    title: "Total Registration",
    price: registration,
    date: "30days",
  };
  return (
    <div>
      <Card>
        <div className="px-5 xl:px-12 py-10">
          <ShouldRender check={loading}>
            <span className="py-10 flex justify-center items-center">
              {" "}
              <Spin size="large" />
            </span>
          </ShouldRender>
          <ShouldRender check={!loading}>
            <CardData data={cardDate} />
          </ShouldRender>
        </div>
      </Card>{" "}
    </div>
  );
};
export default RegisterSection;
